<template>
  <div class="dashboard">


    <swiper class="metric-swiper" :slides-per-view="3" :space-between="15" :centered-slides="false"
      :navigation="false" :pagination="false" :breakpoints="{
        200: { slidesPerView: 1.1 },
        400: { slidesPerView: 1.1 },
        550: { slidesPerView: 2.5 },
        768: { slidesPerView: 3.5 },
        1024: { slidesPerView: 2.5 },
        1200: { slidesPerView: 4 }
      }">
      <swiper-slide v-for="item in cards" :key="item.key">
        <CardComponent :title="item.title" :cantidad="item.cantidad" :loading="loading" :icon="item.icon"
          :tone="item.tone" />
      </swiper-slide>
    </swiper>

    <div class="row g-3 dashboard-main">
      <estadistica />

      <div
        class="float_whatsapp d-none d-sm-none d-md-inline d-lg-inline d-xl-inline col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12">
        <a :href="textAyuda" target="_blank">
          <div style="justify-content: space-between; display: flex">
            <svg width="30" class="my-float" style="margin-top: 7px; margin-left: 10px" height="30" viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
              <path
                d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
            </svg>

            <p class="dudas_txt">¿Dudas o problemas? Contácte con soporte</p>
          </div>
        </a>
      </div>

      <div class="d-inline d-sm-inline d-md-none d-lg-none d-xl-none col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12">
        <a class="float" :href="textAyuda" target="_blank">
          <svg width="30" class="my-float" style="margin-top: 14px" height="30" viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
            <path
              d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
          </svg>
        </a>
      </div>


    </div>
  </div>
</template>
<script>
/*eslint-disable */

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import CardComponent from './CardComponent.vue';
import Estadistica from "./Estadistica.vue";


export default {
  name: "dashboard-default",
  data() {
    let datos = JSON.parse(localStorage.getItem("userData"));

    return {
      isMobile: this.$isMobile,
      tokenAuth: localStorage.getItem("tokenAuth"),
      user: datos.email,
      loading: true,
      showModal: false,
      showModal2: false,
      showQr: false,
      isMobile: this.$isMobile,
      cards: [
        { key: "cantidadPacientes", title: "Pacientes", cantidad: 0, icon: "fas fa-users", tone: "blue" },
        { key: "cantidadAtenciones", title: "Atenciones", cantidad: 0, icon: "fas fa-notes-medical", tone: "teal" },
        { key: "cantidadEnProcesos", title: "En proceso", cantidad: 0, icon: "fas fa-hourglass-half", tone: "amber" },
        { key: "cantidadAusentes", title: "Ausentes", cantidad: 0, icon: "fas fa-user-clock", tone: "pink" }
      ],
      textAyuda: 'https://api.whatsapp.com/send?phone=+593985067512&text=Hola,%20estoy%20usando%20la%20plataforma%20de%20*Urmedical*%20y%20necesito%20ayuda.%20Mi%20correo%20es:%20' + datos.email


    };
  },
  components: {
    Swiper,
    SwiperSlide,
    CardComponent,
    Estadistica
  },

  computed: {
    // Get user role from localStorage
    userRole() {
      const encryptedRole = localStorage.getItem("aut");
      if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
        return this.$encryptBackoffice.decrypt(encryptedRole);
      }
      return null;
    },
  },

  mounted() {

    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }

    let userData = JSON.parse(localStorage.getItem("userData"));
    let revisaSesion = userData ? userData.displayName : null;
    let session = localStorage.getItem("session");

    if(revisaSesion === "" || session === null){
      localStorage.clear();
      location.reload(true);
      this.$router.push({ name: 'Signin' })
    }

    this.getCantidades()

  },


  methods: {

    reloadData() {
      alert('Recargando datos')
    },

    async getCantidades() {
      this.loading = true;
      try {

        const response = await this.$https.post("/estadistica/getLoadDashboardCantidades", { email: this.user, role: this.userRole }, { headers: { Authorization: this.tokenAuth } });

        if (response.data.code === 200) {
          const datos = response.data.datos;

          this.cards = this.cards.map(card => ({
            ...card,
            cantidad: datos[card.key] ?? 0
          }));
        }
        this.loading = false;

      } catch (error) {
        this.loading = false
        if (error.response.status === 400) {

          this.showErrorMejor(error.response.data.message)

        }
        if (error.response.status === 401) {
          this.showSessionExpiredAlert()
        }
      }
    },



  },
  created() { },
  beforeUnmount() {


  },

  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },
  deactivated() {
    // console.log("About has been deactivated");
  },


};
</script>

<style scoped>
.dashboard {
  padding: 8px 12px 24px;
}

.dashboard-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.dashboard-head h5 {
  margin: 0;
  color: #1f2a37;
  font-weight: 700;
}

.dashboard-head p {
  margin: 2px 0 0;
  color: #6b7c8f;
  font-size: 0.82rem;
}

.btn-actualizar {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d5e3ef;
  border-radius: 10px;
  padding: 8px 12px;
  background: #fff;
  color: #0078be;
  font-size: 0.82rem;
  font-weight: 700;
}

.btn-actualizar:disabled {
  opacity: 0.7;
}

.metric-swiper {
  margin-bottom: 16px;
}

.metric-swiper :deep(.swiper-slide) {
  height: auto;
}

.dashboard-main {
  align-items: stretch;
}

@media (max-width: 640px) {
  .dashboard-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
